import React from 'react';
import { FormControlLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { observer } from 'mobx-react-lite';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StandardFieldProps } from './FieldTypes';

dayjs.extend(utc);

const StandardDateField = ({
  control,
  fieldName,
  field,
  readOnly,
}:StandardFieldProps) => (
  <Controller
    name={fieldName}
    control={control}
    render={({
      field: {
        onChange,
        onBlur,
        value,
        name,
      },
      fieldState: {
        // invalid,
        isTouched,
        // isDirty,
        error,
      },
    }) => (
      <FormControlLabel
        label={field.label}
        disabled={field.readOnly}
        labelPlacement="top"
        sx={{ alignItems: 'flex-start' }}
        control={(
          <DatePicker
            slotProps={{
              textField: {
                name: fieldName,
                id: fieldName,
                onBlur,
                error: isTouched && !!error,
              },
            }}
            name={name}
            // label={field.label}
            value={value ? dayjs.utc(value) : null}
            onChange={(date) => {
              console.log('New date', date);
              onChange(date ? date.toDate() : null);
            }}
            // slots={{
            //   textField: TextField,
            // }}
            disabled={field.readOnly || readOnly}
          />
        )}
      />
    )}
  />
);

export default observer(StandardDateField);
